import React from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import PauseIcon from '@mui/icons-material/Pause';
import { EntityDetailCardSection } from '../EntityDetailCard';
import { jobIconStatusMap } from '../utils';
import { Flow, FlowModel } from '../../../types/flow.types';
import CopyToClipboard from '../../CopyToClipboard';

interface Props {
  flow: Flow | FlowModel | null;
  isLoading?: boolean;
  isSuccess?: boolean;
}

const FlowHeaderTitleSection: React.FC<Props> = ({ flow, isLoading }) => (
  <EntityDetailCardSection sx={{ display: 'flex' }}>
    {isLoading ? (
      <div style={{ width: '100%' }}>
        <Skeleton variant="text" width="100%" height={30} />
        <Skeleton variant="text" width="80%" />
        <Skeleton sx={{ marginTop: 2 }} variant="text" width="90%" />
      </div>
    ) : (
      <>
        {!flow && (
          <>
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="80%" />
          </>
        )}
        {flow && (
          <EntityDetailCardSection
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            <span style={{ marginLeft: -16, marginRight: 4, marginTop: 3 }}>
              {!flow?.enabled && <PauseIcon htmlColor="rgb(189, 189, 189)" />}
              {flow?.enabled &&
                ['healthy', 'unhealthy'].includes(
                  flow?.['health-status']?.status || '',
                ) && (
                  <>
                    {flow?.['health-status']?.status === 'healthy' &&
                      jobIconStatusMap['success']}
                    {flow?.['health-status']?.status === 'unhealthy' &&
                      jobIconStatusMap['failed']}
                  </>
                )}
            </span>
            <span>
              <Tooltip
                title={
                  <div>
                    <strong>Flow Name:</strong> {flow?.name} <br />
                    <strong>Flow ID:</strong> {flow?.id} <br />
                    <strong>Status:</strong> {flow?.['health-status']?.status}{' '}
                    {!flow?.enabled && '(disabled)'}
                  </div>
                }
                sx={{ margin: 0, padding: 0 }}
              >
                <span>
                  <Typography
                    variant="h6"
                    fontFamily={'Source Serif Pro'}
                    fontWeight={700}
                    sx={{ width: '100%', color: '#3174AB' }}
                    noWrap={true}
                    data-cy="flow-header-title-name"
                  >
                    {flow?.name}
                  </Typography>
                </span>
              </Tooltip>

              <CopyToClipboard
                displayText={
                  flow?.id?.split('-')[flow?.id?.split('-').length - 1]
                }
              >
                {flow?.id || ''}
              </CopyToClipboard>

              <Typography
                sx={{ marginTop: '5px', paddingRight: '10px' }}
                variant="body2"
                color="black"
                data-cy="flow-header-title-description"
              >
                {flow?.description}
              </Typography>
            </span>
          </EntityDetailCardSection>
        )}
      </>
    )}
  </EntityDetailCardSection>
);

export default FlowHeaderTitleSection;
